import { Button, Flex, Space, Spin } from 'antd';
import {useState, useEffect, useMemo} from "react";
import _ from 'lodash-es';
import request from "../../../libs/request";
import Evisit from "../../../libs/Evisit";
import intl from "react-intl-universal";

async function postSMSAlert(visitId, phone) {
    return request.post(`${window.base_url}/api_v3/visits/${visitId}/sms_alert`, {phone});
}

const WalkinConfirmation = ({onNext, data, isMobileWebview, endWorkflow, currentComponent}) => {

    const [loading, setLoading] = useState(true);
    const [queue, setQueue] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(window.user?.phone || '');
    const [phoneNumberValid, setPhoneNumberValid] = useState(true);
    const [showEditPhone, setShowEditPhone] = useState(false);

    const {visitId, intakeId} = useMemo(() => ({
        visitId: data?.visit?.value?.id,
        intakeId: data?.visit?.value?.intake_id
    }), [data]);

    const beforeMe = useMemo(() => (queue?.before_me || 0) + 1, [queue]);

    const description = useMemo(() =>
        window.CONFIG.Account?.features?.hold_my_spot?.show_prejoin_confirmation?.description
        || intl.get('prejoin_confirmation_description', {provider: Evisit.t('provider')})
                .d('Please standby and be prepared to join the video call when notified. We will send you a notification, and a text if you’ve entered your mobile number, as soon as the {provider} is ready.'),
        []
    );

    const displayVisitId = useMemo(() => {
        return Evisit.getDisplayVisitId(_.get(data, "visit.value"));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    useEffect(() => {
        async function fetchQueue() {
            if (_.get(data, "room.value.code")) {
                let params = `walkinId=${visitId}` + (intakeId ? `&intakeId=${intakeId}` : '');
                const result = await request.get(
                    `${window.base_url}/api_v3/rooms/${data.room.value.code}/queue?${params}`
                );
                setQueue(result && result["data"] ? result["data"] : null);
            }
            setLoading(false);
        }
        fetchQueue();
    }, [data, visitId, intakeId]);

    useEffect(() => {
        phoneNumber && Evisit.validatePhoneNumber(phoneNumber) && postSMSAlert(visitId, phoneNumber);
    }, [phoneNumber]);

    const onSubmit = () => {
        Evisit.executeActions("submit", currentComponent , {}, data).then(response => {
            onNext(response);
        })
    }

    return (
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
            { loading ? <div className="align-center">
                <Spin size="large" />
            </div> : (
            <div>
                <br/>You are <strong>#{beforeMe}</strong> in line. Your Encounter ID is #{displayVisitId}
                <br/><br/>
                {description}
                <br/><br/>
                Mobile number: {showEditPhone
                    ? <input
                        defaultValue={phoneNumber}
                        onChange={(event) => {
                            const phone = event.target.value;
                            const isValid = Evisit.validatePhoneNumber(phone) || phone === '';
                            setPhoneNumberValid(isValid);
                            isValid && setPhoneNumber(phone);
                        }}
                    /> : (<>
                        <span className="phone-number-h6">{phoneNumber} </span>
                        <a href="#" onClick={() => {setShowEditPhone(true)}}>
                            <i className="fa fa-edit"></i>
                        </a>
                    </>)
                }
                <br/><br/>
            </div>)
            }
            <Flex justify={isMobileWebview ? "center" : "flex-end"} gap="small">
                <Button
                    disabled={!phoneNumberValid}
                    type="primary"
                    shape={isMobileWebview ? "round" : "default"}
                    size={isMobileWebview ? "large" : "default"}
                    onClick={onSubmit}
                >
                    Enter Waiting Room Now
                </Button>
                <Button
                    disabled={!phoneNumberValid}
                    shape={isMobileWebview ? "round" : "default"}
                    size={isMobileWebview ? "large" : "default"}
                    onClick={() => {
                        // This is a hacky solution.
                        // Set the type to 0. So the page won't redirect to the visit detail page
                        _.set(data, "visit.value.type", 0);
                        // call the endWorkflow function to close the modal
                        endWorkflow();
                    }}
                >
                    Return to Home
                </Button>
            </Flex>
        </Space>
    );
}

export default WalkinConfirmation;